import React from 'react'
import { Table, Column } from 'react-virtualized'
import { Loading } from './Loading';
import { DetailWindowItemsAsync, DetailWindowSummaryAsync, DetailWindowRecords } from './fetchData';
import Select from 'react-select';
import "abortcontroller-polyfill/dist/polyfill-patch-fetch"

export default class DetailWindow extends React.PureComponent {

	constructor(props) {
	  super(props);
	  const viewID = props.id
	  const datasetID = props.datasetID
	  const numDetails = props.numDetails
	  const mainPanelSelection = props.mainPanelSelection
	  const viewType = props.viewType
	  const DefaultField = props.DefaultField.FieldID
		const FieldArray = props.FieldArray
		const DetailFields = props.DetailFields
		const appURL = props.appURL
		let height = 0;
		if (numDetails > 0){
			height = window.innerHeight/numDetails - 90 - 4 * numDetails
		}
	  this.state = {
		listItems: [],
		datasetID: datasetID,
		viewID: viewID,
		selectedFieldID: '',
		loading: true,
		appURL: appURL,
		reloading: true,
		fieldAndRecordsSelected: false,
		headerHeight: 10,
		width: 240,
		hideIndexRow: false,
		overscanRowCount: 50,
		rowHeight: 20,
		numDetails: numDetails,
		indexes: [],
		names: [],
		recCounts: [],
		height: height,
		rowCount: 1,
		totalRows: 0,
		columnCount: 2,
		mainPanelSelection: mainPanelSelection,
		sortBy: "",
		currentSort: {
			Key: "Rec",
			Direction: "Desc"
		},
		sortedList: "",
		useDynamicRowHeight: false,
		fieldNames: FieldArray,
		DetailFields: DetailFields,
		autoWidth: true,
		viewType: viewType,
		selectedDetailIDsForGettingRecordSetsToHighlightInTitleView: [],
		lastSelection: "",
		DefaultFieldID: DefaultField,
		DefaultFieldLabel: ""
	  };
  
	  this._getDatum = this._getDatum.bind(this);
	  this._columnCellRenderer = this._columnCellRenderer.bind(this);
	  this.updateDetailWindow = this.updateDetailWindow.bind(this);
	  this._headerRenderer = this._headerRenderer.bind(this);
	  this._noRowsRenderer = this._noRowsRenderer.bind(this);
	  this.onRowClick = this.onRowClick.bind(this);
	  this._sort = this._sort.bind(this);
	}
	updateDimensions = () => {
		let numDetails = this.state.numDetails
		let height = 0;
		if (numDetails > 0){
			height = window.innerHeight/numDetails - 80 - 4 * numDetails
		}
		this.setState({ height: height });
	};
	fetchData(appURL, fields, DefaultFieldID){
		let defaultFieldLabel = "";
		let selectedFieldID = "";
		for (var item of fields){
			if (String(item.value) === DefaultFieldID){
				defaultFieldLabel = String(item.label);
				selectedFieldID = String(item.value)
			}
		}
		this.setState({
			fieldNames: fields,
			loading: false,
			DefaultFieldLabel: defaultFieldLabel,
			selectedFieldID: selectedFieldID,
			fieldAndRecordsSelected: false
		})
	}
	UpdateWindowData(appURL, datasetID, selectedFieldID, viewID, mainPanelSelection){
	
	DetailWindowSummaryAsync(appURL, datasetID, selectedFieldID, viewID, mainPanelSelection, mainPanelSelection.browserSelectString, this.abortControllerSummary.signal)
	.then((RowCount) => {
		if (RowCount > 0){
			//let tempRowCount = (RowCount > 5 ? 5 : RowCount)
			if (this.mounted){
			  this.setState({
				selectedDetailIDsForGettingRecordSetsToHighlightInTitleView: [],
				mainPanelSelection: this.props.mainPanelSelection,
				rowCount: RowCount,
				totalRows: RowCount,
				fieldAndRecordsSelected: true,
			  })
			}
			let Blocks = 1;
			//let myTimeout = setTimeout(() => {
				let fetchBlocks = 500
				let sortDirection = this.state.currentSort.Key + this.state.currentSort.Direction
				for (var index = 0; index < RowCount; index += fetchBlocks) {
					DetailWindowItemsAsync(appURL, datasetID, selectedFieldID, viewID, mainPanelSelection, mainPanelSelection.browserSelectString, index, fetchBlocks, sortDirection, this.abortControllerItems.signal)
					.then((data) => {
						let indexes = this.state.indexes
						let names = this.state.names
						let recCounts = this.state.recCounts
						if (indexes !== []){
							indexes = indexes.concat(JSON.parse(data.RowLabels.indexes))
							names = names.concat(JSON.parse(data.RowLabels.names))
							recCounts = recCounts.concat(JSON.parse(data.RowLabels.recs))
						}
						else {
							indexes = JSON.parse(data.RowLabels.indexes)
							names = JSON.parse(data.RowLabels.names)
							recCounts = JSON.parse(data.RowLabels.recs)
						}
						if (this.mounted){
							this.setState({
								indexes: indexes,
								names: names,
								recCounts: recCounts,
								reloading: false
							})
						}
					})
				}
			//}, Blocks)
		  }
		  else {
			  this.setState({
				listItems: [],
				names: [],
				indexes: [],
				recCounts: [],
				rowCount: 0,
				totalRows: 0,
				selectedDetailIDsForGettingRecordSetsToHighlightInTitleView: [],
				reloading: false
			  })
		  }
	  })
	}
	EmptyDetailData(mainPanelSelection){
	  this.setState({
		listItems: [],
		names: [],
		indexes: [],
		recCounts: [],
		rowCount: 0,
		totalRows: 0,
		mainPanelSelection: mainPanelSelection,
		fieldAndRecordsSelected: false,
		selectedDetailIDsForGettingRecordSetsToHighlightInTitleView: [],
		reloading: false
	  })
	}
	  componentDidMount(){
		  this.mounted = true;
		  this.fetchData(this.state.appURL, this.state.fieldNames, this.state.DefaultFieldID)
	  }
	  

	  componentDidUpdate(prevProps, prevState){
		window.addEventListener('resize', this.updateDimensions);
		  if (JSON.stringify(prevProps.mainPanelSelection) !== JSON.stringify(this.props.mainPanelSelection) || this.state.selectedFieldID !== prevState.selectedFieldID){
			this.setState({
				reloading: true
			})
		  if (this.state.selectedFieldID !== '' && this.props.mainPanelSelection.bSelection){

			this.setState({
				reloading: true,
				listItems: {},
				names: [],
				indexes: [],
				recCounts: [],
				rowCount: 0,
				totalRows: 0
			})
			this.UpdateWindowData(this.state.appURL, this.state.datasetID, this.state.selectedFieldID, this.state.viewID, this.props.mainPanelSelection)
		  }
		  else if (!this.props.mainPanelSelection.bSelection){
			this.EmptyDetailData(this.props.mainPanelSelection)
		  }
		}
		
		else if (this.state.selectedDetailIDsForGettingRecordSetsToHighlightInTitleView !== prevState.selectedDetailIDsForGettingRecordSetsToHighlightInTitleView && this.state.selectedDetailIDsForGettingRecordSetsToHighlightInTitleView.length > 0){
		  DetailWindowRecords(this.state.appURL, this.state.datasetID, this.state.selectedFieldID, this.state.viewID, this.props.mainPanelSelection, this.state.selectedDetailIDsForGettingRecordSetsToHighlightInTitleView, this.state.rowCount)
		  .then((data) => {
			if (this.mounted){
				this.props.callbackFromParent(data)
			}
		  })
		}
	  }
	  componentWillUnmount(){
		  this.mounted = false;
		  this.abortControllerFields.abort();
		  this.abortControllerSummary.abort();
		  this.abortControllerItems.abort();
		  window.removeEventListener('resize', this.updateDimensions);
	  }
	  abortControllerFields = new window.AbortController();
	  abortControllerSummary = new window.AbortController();
	  abortControllerItems = new window.AbortController();
	  render() {
		const {
		  headerHeight,
		  height,
		  width,
		  overscanRowCount,
		  columnCount,
		  autoWidth,
		  rowHeight,
		  rowCount,
		  scrollToIndex,
		  sortBy,
		  sortDirection,
		  fieldNames,
		  DetailFields,
		  useDynamicRowHeight,
		} = this.state;
		const rowGetter = ({index}) => this._getDatum(index);
		return (
		  <div>
			{this.state.loading === true ?
			<Loading />
			: <div className="DetailWindow">
			<Select key={this.state.DefaultFieldID} options={DetailFields} openMenuOnClick={false} openMenuOnFocus={false} onChange={this.updateDetailWindow} defaultValue={{ label: this.state.DefaultFieldLabel, value: this.state.DefaultFieldID }}></Select>
			{/*<div className="DetailFieldName">{this.state.DefaultFieldLabel}</div>*/}
			{this.state.reloading === true
			? <Loading />
			: this.state.fieldAndRecordsSelected === false
			? <div></div>
			:<Table
				ref="Table"
				headerClassName={"DetailHeaderRow"}
				headerHeight={headerHeight}
				headerRowRenderer={this._headerRenderer}
				height={height}
				className={"DetailWindowGrid"}
				noRowsRenderer={this._noRowsRenderer}
				overscanRowCount={overscanRowCount}
				rowHeight={useDynamicRowHeight ? this._getRowHeight : rowHeight}
				rowGetter={rowGetter}
				rowCount={rowCount}
				columnCount={columnCount}
				scrollToIndex={scrollToIndex}
				sort={this._sort}
				sortBy={sortBy}
				sortDirection={sortDirection}
				autoWidth={autoWidth}
				onRowClick={this.onRowClick}
				width={width}>
				<Column
					dataKey="RecordCount"
					cellRenderer={({cellData}) => cellData}
					width={30}
				/>
				{/*<Column
					dataKey="Expectancy"
					cellRenderer={({cellData}) => {
					  switch(true){
						case (cellData > 0.99):
						  return <div className="DetailIcon"><div className="ThreeUpArrow" title={cellData}></div></div>;
						case (cellData >= 0.95):
						  return <div className="DetailIcon"><div className="TwoUpArrow" title={cellData}></div></div>;
						case (cellData >= 0.9):
						  return <div className="DetailIcon"><div className="OneUpArrow" title={cellData}></div></div>;
						case (cellData < -0.99):
						  return <div className="DetailIcon"><div className="ThreeDownArrow" title={cellData}></div></div>;
						case (cellData <= -0.95):
						  return <div className="DetailIcon"><div className="TwoDownArrow" title={cellData}></div></div>;
						case (cellData <= -0.9):
						  return <div className="DetailIcon"><div className="OneDownArrow" title={cellData}></div></div>;
						default:
						  return <div className="DetailIcon"><div className="NoArrow" title={cellData}></div></div>;
					  }
					}}
					width={30}
				/>*/}
				<Column
					dataKey="Name"
					cellRenderer={this._columnCellRenderer}
					  
					
					width={210}
				/>
			  </Table>
			}
			</div>
			}
			</div>
		)
	  }

	  _sort(dataKey) {
		const currentSort = this.state.currentSort
		let newSortKey = dataKey
		let newSortDir = "Desc"
		if (currentSort.Key === dataKey){
			if (currentSort.Direction === "Desc"){
				newSortDir = "Asc"
			}
			else {
				newSortDir = "Desc"
			}
		}
		this.setState({
		  currentSort: {
			Key: newSortKey,
			Direction: newSortDir
		  },
		  sortOrderArray: [],
		  indexes: [],
		  names: [],
		  recCounts: []
		});
		this.UpdateWindowData(this.state.appURL, this.state.datasetID, this.state.selectedFieldID, this.state.viewID, this.state.mainPanelSelection)
	  }
	
	  _noRowsRenderer() {
		return <div className={"noRows"}></div>;
	  }
	  _getDatum( index) {
		var returnObj = {
		  Index: index,
		  RecordGroup: this.state.indexes[index],
		  Name: this.state.names[index],
		  RecordCount: this.state.recCounts[index]
		  //Expectancy: this.state.listItems.RowLabels["Prob" + this.state.sortOrderArray[index]]
		}
		return returnObj;
	  }
	  _columnCellRenderer = ({dataKey, parent, rowIndex}) => {
		const selectedDetailIDsForGettingRecordSetsToHighlightInTitleView = this.state.selectedDetailIDsForGettingRecordSetsToHighlightInTitleView;
		const datum = this._getDatum(rowIndex)
		var classNames;
		if (selectedDetailIDsForGettingRecordSetsToHighlightInTitleView.includes(String(datum.RecordGroup))){
		  classNames = "selected";
		}
		return (
			<div title={datum[dataKey]} className={classNames}>
			  {datum[dataKey]}
			</div>
		);
	  };
	  onRowClick(event){
		if (event.event.ctrlKey){
		  this.setState({
			selectedDetailIDsForGettingRecordSetsToHighlightInTitleView: this.state.selectedDetailIDsForGettingRecordSetsToHighlightInTitleView.concat(String([event.rowData.RecordGroup])),
			lastSelection: event.index
		  })
		}
		else if (event.event.shiftKey){
		  if (this.state.lastSelection !== ""){
			var IDArray = [];
			if (this.state.lastSelection < event.index){
			  for (let i=this.state.lastSelection; i<=event.index; i++){
				IDArray.push( String( this.state.indexes[i]))
			  }
			}
			else {
			  for (let i=this.state.lastSelection; i>=event.index; i--){
				IDArray.push( String(this.state.indexes[i]))
			  }
			}
			this.setState({
			  selectedDetailIDsForGettingRecordSetsToHighlightInTitleView: IDArray,
			  lastSelection: event.index
			});
		  }
		}
		else {

		  this.setState({
			selectedDetailIDsForGettingRecordSetsToHighlightInTitleView: [String(event.rowData.RecordGroup)],
			lastSelection: event.index
		  })
		}
	  }

	  updateDetailWindow(val){
		this.setState({
		  selectedFieldID: val.value,
		  selectedDetailIDsForGettingRecordSetsToHighlightInTitleView: []
		})
	  }

	  _headerRenderer() {

		return (
		  <div className="ReactVirtualized__Table__row" style={{height: this.state.headerHeight, width: this.state.width}}>
			<div style={{flex: "0 1 30px"}} className="ReactVirtualized__Table__rowColumn" onClick={() => this._sort("Rec")}></div>
			{/*<div style={{flex: "0 1 30px"}} className="ReactVirtualized__Table__rowColumn" onClick={() => this._sort("Prob")}></div>*/}
			<div style={{flex: "0 1 210px"}} className="ReactVirtualized__Table__rowColumn" onClick={() => this._sort("Alpha")}></div>
		  </div>
		);
	  }    
}